import { render, staticRenderFns } from "./SearchError.vue?vue&type=template&id=15b09f95&scoped=true&"
import script from "./SearchError.vue?vue&type=script&lang=js&"
export * from "./SearchError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b09f95",
  null
  
)

export default component.exports